module.exports = __webpack_public_path__ + "static/media/logo-registro-pay-branca.db30fa98.png";